import { ImpressionData, ProductData, ActionData } from './data';

interface GtmEcommerce {
  currencyCode?: string;
  impressions?: ImpressionData[];
  detail?: {
    actionField?: {
      list: string;
    };
    products: ProductData[];
  };
  add?: {
    products: ProductData[];
  };
  remove?: {
    products: ProductData[];
  };
  checkout?: {
    actionField?: {
      step?: number;
      option?: string;
    };
    products: ProductData[];
  };
  'checkout_option'?: {
    actionField: {
      step?: number;
      option?: string;
    };
  };
  purchase?: {
    actionField?: ActionData;
    products: ProductData[];
  };
}

interface DataLayerGtm {
  event: string;
  ecommerce?: GtmEcommerce;
}

export function push(layer: DataLayerGtm) {
  const win = window as any;
  (win.dataLayer || (win.dataLayer = [])).push(layer);
}